import React, { useState, useEffect } from 'react';
import PocketBase from 'pocketbase';
import sellBannerImg from '../assets/sell_banner.jpg'; 

const pb = new PocketBase('https://bahcarplaza.com');

const CITIES = ['Kolkata', 'Mumbai', 'Delhi', 'Bangalore', 'Chennai', 'Pune', 'Hyderabad', 'Ahmedabad', 'Jaipur'];
const CURRENT_YEAR = new Date().getFullYear();
const YEARS = Array.from({ length: 26 }, (_, i) => CURRENT_YEAR - i); 
const BODY_TYPES = ['Hatchback', 'Sedan', 'SUV', 'MUV'];
const SEATS = ['4 Seater', '5 Seater', '6 Seater', '7 Seater', '9 Plus Seater']; 

const BRAND_LOGOS = {
  'Maruti Suzuki': 'https://i.pinimg.com/1200x/f1/04/16/f1041698a90aea121f8da53acf1a8f92.jpg',
  'Hyundai': 'https://upload.wikimedia.org/wikipedia/commons/thumb/4/44/Hyundai_Motor_Company_logo.svg/2048px-Hyundai_Motor_Company_logo.svg.png',
  'Honda': 'https://upload.wikimedia.org/wikipedia/commons/thumb/7/7b/Honda_Logo.svg/2048px-Honda_Logo.svg.png',
  'Tata': 'https://upload.wikimedia.org/wikipedia/commons/thumb/8/8e/Tata_logo.svg/2048px-Tata_logo.svg.png',
  'Mahindra': 'https://i.pinimg.com/1200x/17/38/ff/1738ff204f7eaaf912742070a0871f8e.jpg',
  'Toyota': 'https://upload.wikimedia.org/wikipedia/commons/thumb/9/9d/Toyota_carlogo.svg/2048px-Toyota_carlogo.svg.png',
  'KIA': 'https://upload.wikimedia.org/wikipedia/commons/thumb/4/47/KIA_logo2.svg/2048px-KIA_logo2.svg.png',
  'Ford': 'https://upload.wikimedia.org/wikipedia/commons/thumb/a/a0/Ford_Motor_Company_Logo.svg/2048px-Ford_Motor_Company_Logo.svg.png',
  'Volkswagen': 'https://upload.wikimedia.org/wikipedia/commons/thumb/6/6d/Volkswagen_logo_2019.svg/2048px-Volkswagen_logo_2019.svg.png',
  'BMW': 'https://upload.wikimedia.org/wikipedia/commons/thumb/4/44/BMW.svg/2048px-BMW.svg.png',
  'Mercedes Benz': 'https://upload.wikimedia.org/wikipedia/commons/thumb/9/90/Mercedes-Logo.svg/2048px-Mercedes-Logo.svg.png',
};

const ALL_BRANDS = ["Maruti Suzuki", "Hyundai", "Honda", "Tata", "Mahindra", "KIA", "Toyota", "Mercedes Benz", "BMW", "Ford", "Volkswagen"];
const COLORS = {'Maroon': '#800000', 'Black': '#000000', 'Silver': '#c0c0c0', 'Gray': '#808080', 'Blue': '#0000ff', 'Red': '#ff0000', 'Green': '#008000', 'Brown': '#a52a2a', 'Orange': '#ffa500', 'Golden': '#ffd700', 'Yellow': '#ffff00'};

// 🚨 Added goBack prop 🚨
function MobileSellCar({ view, setView, goBack, setActiveTab }) {
  useEffect(() => { if (!pb.authStore.isValid) setView('auth'); }, [setView]);

  const [step, setStep] = useState(1);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [sellCarData, setSellCarData] = useState({
    brand: '', model: '', year: '', price: '', kilometers_driven: '', mileage: '', owner_type: '', body_type: '', seats: '', number_plate: '',
    fuel_type: [], transmission: [], city: [], color: []
  });
  const [sellCarImages, setSellCarImages] = useState(null);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // ==========================================
  // 🚨 HARDWARE BACK BUTTON INTERCEPTOR 🚨
  // ==========================================
  useEffect(() => {
    const handlePopState = (event) => {
      // If the user is on Step 2 or 3, we want to intercept the hardware back button
      // and take them to the previous step instead of leaving the page entirely.
      if (step > 1) {
        setStep(prevStep => prevStep - 1);
        
        // Push a dummy state back so the browser doesn't actually leave
        // This keeps us 'trapped' in the sell page until step is 1
        window.history.pushState({ page: 'sell_car_new', step: step - 1 }, '');
      }
    };

    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, [step]);

  if (!pb.authStore.isValid) return null; 

  const toggleSelection = (field, value) => {
    setSellCarData(prev => {
      const currentList = prev[field];
      if (currentList.includes(value)) return { ...prev, [field]: currentList.filter(item => item !== value) };
      return { ...prev, [field]: [...currentList, value] };
    });
  };

  const handleNext = () => {
    if (step === 1 && !sellCarData.brand) return alert("Please select a brand first!");
    if (step === 2) {
      if (!sellCarData.model || !sellCarData.year || !sellCarData.price || !sellCarData.mileage || !sellCarData.kilometers_driven || !sellCarData.body_type || !sellCarData.owner_type || !sellCarData.seats || sellCarData.city.length === 0) {
        return alert("Please fill all the details. (Number Plate is optional)");
      }
    }
    
    // 🚨 Sync forward movement with history state 🚨
    const nextStep = step + 1;
    setStep(nextStep);
    window.history.pushState({ page: 'sell_car_new', step: nextStep }, '');
    window.scrollTo(0, 0);
  };

  // 🚨 Custom Back Button Handler 🚨
  const handleCustomBack = () => {
    if (step > 1) {
      // If we are deep in the steps, simulate a hardware back press
      window.history.back(); 
    } else {
      // If we are on step 1, use the main app routing to go back to previous page
      goBack(); 
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (sellCarData.fuel_type.length === 0 || sellCarData.transmission.length === 0 || sellCarData.color.length === 0) return alert("Please select Fuel Type, Transmission, and Color.");
    if (!sellCarImages || sellCarImages.length === 0) return alert("Please upload at least one image of your car.");

    setIsSubmitting(true);
    try {
      const formData = new FormData();
      formData.append('brand', sellCarData.brand); formData.append('model', sellCarData.model); formData.append('year', sellCarData.year);
      formData.append('price', sellCarData.price); formData.append('mileage', sellCarData.mileage); formData.append('kilometers_driven', sellCarData.kilometers_driven);
      formData.append('owner_type', sellCarData.owner_type); formData.append('body_type', sellCarData.body_type);
      formData.append('seats', sellCarData.seats); 
      if (sellCarData.number_plate) formData.append('number_plate', sellCarData.number_plate.toUpperCase()); 
      
      formData.append('status', 'Pending'); formData.append('user_car', true); formData.append('added_by', pb.authStore.model.id); 
      
      sellCarData.color.forEach(v => formData.append('color', v)); sellCarData.fuel_type.forEach(v => formData.append('fuel_type', v));
      sellCarData.transmission.forEach(v => formData.append('transmission', v)); sellCarData.city.forEach(v => formData.append('city', v));
      Array.from(sellCarImages).forEach(file => { formData.append('image', file); });

      await pb.collection('cars').create(formData);
      alert("✅ Car Listed Successfully! Wait for Admin Approval.");
      if(setActiveTab) setActiveTab('My Ad'); setView('account');
    } catch (error) { alert("Submission Failed: " + error.message); }
    setIsSubmitting(false);
  };

  const inputStyle = { padding: '15px', borderRadius: '12px', border: '1px solid #e5e7eb', backgroundColor: '#f9fafb', fontWeight: 'bold', width: '100%', fontSize: '14px', outline: 'none' };
  const labelStyle = { fontSize: '11px', fontWeight: '900', color: '#6b7280', textTransform: 'uppercase', marginBottom: '5px', display: 'block' };

  return (
    <div className="min-h-screen bg-[#f4f7f6] pb-24 font-sans flex flex-col">
      <style>{`.hide-scrollbar::-webkit-scrollbar { display: none; } .hide-scrollbar { -ms-overflow-style: none; scrollbar-width: none; } @keyframes fadeIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } } .animate-fadeIn { animation: fadeIn 0.4s ease-out forwards; }`}</style>
      
      <div className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-[#012b72] shadow-md py-3' : 'bg-[#012b72] pt-4 pb-4 shadow-none rounded-b-[1.5rem]'}`}>
        <div className="px-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <button onClick={handleCustomBack} className="bg-white/20 w-8 h-8 rounded-full border-none text-white text-lg flex items-center justify-center font-bold cursor-pointer hover:bg-white/30 transition-colors">←</button>
            <h2 className="m-0 font-black text-[16px] text-white uppercase tracking-wide">Sell Car <span className="text-[#ef5e33] text-xs font-bold ml-1">Step {step}/3</span></h2>
          </div>
        </div>
        <div className={`px-4 mt-3 transition-opacity duration-300 ${isScrolled ? 'hidden' : 'block'}`}><div className="w-full bg-white/20 h-1.5 rounded-full overflow-hidden"><div className="bg-[#ef5e33] h-full transition-all duration-300" style={{ width: `${(step / 3) * 100}%` }}></div></div></div>
      </div>

      <div className={`transition-all duration-300 ${isScrolled ? 'h-[60px]' : 'h-[100px]'}`}></div>

      {step === 1 && (
        <div className="px-4 py-2 animate-fadeIn">
          <div className="w-full h-[300px] rounded-2xl overflow-hidden mb-6 shadow-md relative bg-gray-900">
            <img src={sellBannerImg} alt="Sell Car Banner" className="w-full h-full object-cover opacity-70" />
          </div>
          <div className="mb-8 bg-white p-5 rounded-[24px] shadow-sm border border-gray-100">
            <h2 className="text-[14px] font-black text-[#002f34] m-0 mb-5 uppercase">Select Brand</h2>
            <div className="grid grid-cols-3 gap-3">
              {ALL_BRANDS.map(brand => (
                <div key={brand} onClick={() => setSellCarData({...sellCarData, brand})} className={`rounded-xl p-3 flex flex-col items-center justify-center border-2 shadow-sm cursor-pointer active:scale-95 transition-all duration-200 ${sellCarData.brand === brand ? 'border-[#ef5e33] bg-[#fff4e6] scale-[1.02]' : 'border-gray-100 bg-gray-50 hover:border-[#ef5e33]'}`}>
                  <div className="w-[50px] h-[50px] flex items-center justify-center mb-2">{BRAND_LOGOS[brand] ? <img src={BRAND_LOGOS[brand]} alt={brand} className="w-full h-full object-contain mix-blend-multiply" /> : <span className="font-black text-2xl text-gray-300">{(brand || "U").charAt(0).toUpperCase()}</span>}</div>
                  <span className={`text-[10px] font-black leading-tight text-center ${sellCarData.brand === brand ? 'text-[#ef5e33]' : 'text-[#002f34]'}`}>{brand.split(' ')[0]}</span>
                </div>
              ))}
            </div>
            {sellCarData.brand && <button onClick={handleNext} className="w-full py-4 mt-6 rounded-xl bg-[#012b72] text-white font-black text-[13px] uppercase tracking-wide shadow-md active:scale-95 transition-transform border-none">Continue ➔</button>}
          </div>
        </div>
      )}

      {step === 2 && (
        <div className="px-4 py-2 flex flex-col gap-4 animate-fadeIn">
          <div className="bg-[#e1f9eb] p-3 rounded-xl border-l-4 border-[#1db954] text-[11px] text-[#1db954] font-black uppercase mb-2 flex items-center gap-2 shadow-sm"><span>✓</span> Selected Brand: {sellCarData.brand}</div>
          <div className="bg-white p-5 rounded-[20px] shadow-sm border border-gray-100 flex flex-col gap-4">
            
            <div className="flex gap-3">
               <div className="flex-1">
                  <label style={labelStyle}>Model Name</label>
                  <input type="text" placeholder="e.g. Nexon XZ+" value={sellCarData.model} onChange={e => setSellCarData({...sellCarData, model: e.target.value})} style={inputStyle} />
               </div>
               <div className="flex-1">
                  <label style={labelStyle}>Reg. Number <span className="text-gray-400 normal-case">(Optional)</span></label>
                  <input type="text" placeholder="WB 00 XX 0000" value={sellCarData.number_plate} onChange={e => setSellCarData({...sellCarData, number_plate: e.target.value})} style={{...inputStyle, textTransform: 'uppercase'}} />
               </div>
            </div>

            <div className="flex gap-3">
              <div className="flex-1"><label style={labelStyle}>City</label><select value={sellCarData.city[0] || ''} onChange={e => setSellCarData({...sellCarData, city: [e.target.value]})} style={inputStyle}><option value="">Select</option>{CITIES.map(c => <option key={c} value={c}>{c}</option>)}</select></div>
              <div className="flex-1"><label style={labelStyle}>Mfg. Year</label><select value={sellCarData.year} onChange={e => setSellCarData({...sellCarData, year: e.target.value})} style={inputStyle}><option value="">Select</option>{YEARS.map(y => <option key={y} value={y}>{y}</option>)}</select></div>
            </div>

            <div><label style={labelStyle}>Expected Price (₹)</label><div className="relative"><span className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-500 font-black">₹</span><input type="number" placeholder="5,00,000" value={sellCarData.price} onChange={e => setSellCarData({...sellCarData, price: e.target.value})} style={{...inputStyle, paddingLeft: '35px'}} /></div></div>

            <div className="flex gap-3">
              <div className="flex-1"><label style={labelStyle}>KM Driven</label><input type="number" placeholder="45000" value={sellCarData.kilometers_driven} onChange={e => setSellCarData({...sellCarData, kilometers_driven: e.target.value})} style={inputStyle} /></div>
              <div className="flex-1"><label style={labelStyle}>Mileage (KMPL)</label><input type="number" placeholder="18" value={sellCarData.mileage} onChange={e => setSellCarData({...sellCarData, mileage: e.target.value})} style={inputStyle} /></div>
            </div>

            <div>
              <label style={labelStyle}>Body Type</label>
              <div className="grid grid-cols-2 gap-3 mt-1">
                {[{ name: 'Hatchback', icon: '🚙' }, { name: 'Sedan', icon: '🚘' }, { name: 'SUV', icon: '🛻' }, { name: 'MUV', icon: '🚐' }].map(type => (
                  <div key={type.name} onClick={() => setSellCarData({...sellCarData, body_type: type.name})} className={`flex items-center gap-3 p-3 rounded-xl border-2 cursor-pointer transition-all active:scale-95 ${sellCarData.body_type === type.name ? 'border-[#012b72] bg-[#e6f0ff] shadow-sm' : 'border-gray-100 bg-[#f9fafb] hover:border-gray-200'}`}>
                    <span className="text-2xl drop-shadow-sm">{type.icon}</span><span className={`text-[12px] font-black uppercase tracking-wider ${sellCarData.body_type === type.name ? 'text-[#012b72]' : 'text-gray-500'}`}>{type.name}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="flex gap-3">
               <div className="flex-1">
                 <label style={labelStyle}>Owner Type</label>
                 <select value={sellCarData.owner_type} onChange={e => setSellCarData({...sellCarData, owner_type: e.target.value})} style={inputStyle}>
                   <option value="">Select</option>{['1st Hand', '2nd Hand', '3rd Hand', 'More Than 3'].map(o => <option key={o} value={o}>{o}</option>)}
                 </select>
               </div>
               <div className="flex-1">
                 <label style={labelStyle}>Seats</label>
                 <select value={sellCarData.seats} onChange={e => setSellCarData({...sellCarData, seats: e.target.value})} style={inputStyle}>
                   <option value="">Select Seats</option>{SEATS.map(s => <option key={s} value={s}>{s}</option>)}
                 </select>
               </div>
            </div>

          </div>
          <button onClick={handleNext} className="w-full py-4 rounded-xl bg-[#012b72] text-white font-black text-[13px] uppercase tracking-wide shadow-md active:scale-95 transition-transform border-none">Next Step ➔</button>
        </div>
      )}

      {step === 3 && (
        <div className="px-4 py-2 flex flex-col gap-4 animate-fadeIn">
          <div className="bg-white p-5 rounded-[20px] shadow-sm border border-gray-100 flex flex-col gap-6">
            <div><label style={labelStyle}>Fuel Type</label><div className="flex gap-2 flex-wrap">{[{name: 'Petrol', icon: '⛽'}, {name: 'Disel', icon: '🛢️'}, {name: 'Electric', icon: '⚡'}, {name: 'CNG', icon: '💨'}].map(f => (<div key={f.name} onClick={() => toggleSelection('fuel_type', f.name)} className={`flex items-center gap-2 px-4 py-2.5 rounded-full border-2 cursor-pointer transition-all font-bold text-xs ${sellCarData.fuel_type.includes(f.name) ? 'border-[#1db954] bg-[#e1f9eb] text-[#1db954]' : 'border-gray-200 text-gray-500 bg-white'}`}><span className="text-lg">{f.icon}</span> {f.name}</div>))}</div></div>
            <div><label style={labelStyle}>Transmission</label><div className="flex gap-2 flex-wrap">{[{name: 'Manual', icon: '⚙️'}, {name: 'Automatic', icon: '🕹️'}].map(t => (<div key={t.name} onClick={() => toggleSelection('transmission', t.name)} className={`flex items-center gap-2 px-4 py-2.5 rounded-full border-2 cursor-pointer transition-all font-bold text-xs ${sellCarData.transmission.includes(t.name) ? 'border-[#012b72] bg-[#012b72] text-white' : 'border-gray-200 text-gray-500 bg-white'}`}><span className="text-lg">{t.icon}</span> {t.name}</div>))}</div></div>
            <div><label style={labelStyle}>Color</label><div className="flex gap-3 flex-wrap">{Object.keys(COLORS).map(color => (<div key={color} onClick={() => toggleSelection('color', color)} className="flex flex-col items-center gap-1 cursor-pointer"><div style={{ backgroundColor: COLORS[color] }} className={`w-10 h-10 rounded-full shadow-sm flex items-center justify-center transition-all ${sellCarData.color.includes(color) ? 'ring-4 ring-offset-2 ring-[#ef5e33] scale-90' : 'border border-gray-200'}`}>{sellCarData.color.includes(color) && <span className="text-white text-sm font-black drop-shadow-md">✓</span>}</div><span className={`text-[9px] font-black ${sellCarData.color.includes(color) ? 'text-[#ef5e33]' : 'text-gray-400'}`}>{color}</span></div>))}</div></div>
            <div><label style={labelStyle}>Upload Images (Required)</label><div className="relative border-2 border-dashed border-[#ef5e33] rounded-2xl p-6 bg-[#fff4e6] text-center cursor-pointer hover:bg-[#ffe0b2] transition-colors"><span className="text-4xl mb-2 block">📸</span><p className="m-0 text-[#ef5e33] font-black text-sm uppercase">Tap to Select Photos</p><p className="m-0 text-gray-500 font-bold text-[10px] mt-1">Upload multiple angles</p><input required type="file" multiple accept="image/*" onChange={(e) => setSellCarImages(e.target.files)} className="absolute inset-0 w-full h-full opacity-0 cursor-pointer" /></div>{sellCarImages && <p className="text-[#1db954] font-black text-xs mt-3 text-center bg-[#e1f9eb] py-2 rounded-lg border border-[#1db954]">✓ {sellCarImages.length} images selected</p>}</div>
          </div>
          <button onClick={handleSubmit} disabled={isSubmitting} className={`w-full py-4 mt-2 rounded-xl text-white font-black text-[13px] uppercase tracking-wide shadow-xl transition-all border-none ${isSubmitting ? 'bg-gray-400' : 'bg-[#ef5e33] active:scale-95'}`}>{isSubmitting ? 'Uploading Ad...' : 'Submit & Post Ad ✓'}</button>
        </div>
      )}
    </div>
  );
}

export default MobileSellCar;